module.exports = __webpack_public_path__ + "static/assets/301c2ca6cba61d47136cb6104657dfab.svg";